import React from 'react';
import { Empty as ATEmpty } from 'antd';
import { EmptyProps } from 'antd/es/empty';
import cs from 'classnames';
import styles from './index.module.less';

const Empty: React.FC<EmptyProps> = (props) => {
  const {
    image = 'https://staticres.linhuiba.com/project-custom/custom-flow/img_404@2x.png', // 缺省图url
    imageStyle, // empty样式
    description = '暂无内容', // 描述内容
    className,
    children,
  } = props;
  return (
    <ATEmpty
      className={cs(styles.customEmpty, className)}
      image={image}
      imageStyle={{ height: 120, ...imageStyle }}
      description={description}
    >
      { children }
    </ATEmpty>
  );
};

export default Empty;
